<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/191A2ie/tc-custom/9789948746188.jpg?1731054780941" alt="This image is the cover for the book اللامستحيل امتناع الحل هو الجواب"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">اللامستحيل امتناع الحل هو الجواب
      </h1>
      <p class="bookDescription body article font2">
        <p>يُحَفِّز هذا الكتاب الأفكار الكامنة التي يتردَّد صداها في أذهان الكثير مِن الخاصَّة والعامَّة، للإجابة عن أهمِّ سؤال في مجال الابتكار والاكتشاف والإبداع، وهو كيف يمكنني أن أكون مبتكِرًا أو مكتشِفًا أو مبدعًا؟ مع تقليب صفحات هذا الكتاب سَيجدُ مَن يقرؤه الإجابة عن مبتغاه، وذلك لاحتوائه على مكتشفات وأعمال أُظْهِرَت للواقع بطُرق غير مألوفة، ويناقش مسائل مستعصية على إيجاد الحلول لها، وتُعتبَر برأي الكثرة الكاثرة مِن المستحيلات، وذلك مِن خلال العصف الذهني لاستخراج المكنون مِن الأفكار الإبداعية، واكتشاف المستور، وتحقيق المطلوب.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        محمد بن محمد منير محروقة
      </h2>
      
      <p class="authorDescription body article">محمد بن محمد منير محروقة مِن مواليد دمشق 1956 بسوريا، تعلَّم بمدارسها، وحصل على البكالوريوس بالعلوم الفيزيائيَّة والكيميائيَّة في جامعة دمشق عام 1979- 1980.  عملَ أستاذًا للفيزياء والكيمياء وبمُختبرات التحليل الإشعاعي بالوقاية الإشعاعيَّة في بعض الدول العربية. ساهَم بإنشاء مختبرات مطيافية جاما لمراقبة تسرُّب الإشعاع للغذاء والبيئة.  عضو في كثير منَ اللِّجان المتخصِّصة بالوقاية الإشعاعية وفِرَق العمل لوَضعِ اللوائح التنظيمية للإشعاع المؤيّن والإشعاع البيئي.  لدَيه خبرة في استعراض الدراسات البيئية لتقييم الآثار البيئية، وإصدار التصاريح البيئية للمشروعات التنمويَّة، وتنفيذ زيارات تفتيشية لمواقع المشروعات والمحميَّات. خبير مؤهَّل بالوقاية الإشعاعية "FANR-037QE" بدولة الإمارات العربية المتحدة. له اهتمامات بإلقاء المحاضرات بالوقاية الإشعاعية، واهتمامات بسلوك الأعداد، ومواهب شِعرية فردية، ومواهب بالرياضة والشطرنج. حصل على العديد مِن الجوائز، أهمُّها جائزة الدانة الذهبية - الفئة التخصُّصيَّة، ووسام الخدمة الطويلة مِن هيئة حكومية بإمارة أبوظبي، ودرع المجلس الأعلى للأمن الوطني.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b05da6f